import { useState } from 'react';

import { Box } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const OBJECTIVE_MOCK_VALUES = [
  { uuid: null, keyName: 'None', displayName: 'None', enabled: true },
  { uuid: null, keyName: 'Revenue generation', displayName: 'Revenue generation', enabled: true },
  {
    uuid: null,
    keyName: 'Strategic Partnerships and Alliances',
    displayName: 'Strategic Partnerships and Alliances',
    enabled: true,
  },
  { uuid: null, keyName: 'Operational Efficiency', displayName: 'Operational Efficiency', enabled: true },
  { uuid: null, keyName: 'Brand Building and Awareness', displayName: 'Brand Building and Awareness', enabled: true },
  { uuid: null, keyName: 'Digital Transformation', displayName: 'Digital Transformation', enabled: true },
];

const ObjectiveDropdownLifecycleFilter = () => {
  const [selectedGroupByValue, setSelectedGroupByValue] = useState(OBJECTIVE_MOCK_VALUES[1]);

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            Objective:
          </TextBodyMedium>
          <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
            <TextBodyMedium bold color="text.g1">
              {selectedGroupByValue?.displayName}
            </TextBodyMedium>
          </Box>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px' }}>
        <DropdownRadioGroup value={selectedGroupByValue?.keyName}>
          {OBJECTIVE_MOCK_VALUES?.map(({ keyName, displayName }) => (
            // @ts-expect-error keyName is incorrectly typed
            <DropdownRadioItem
              key={keyName}
              value={keyName}
              onClick={() => {
                setSelectedGroupByValue(OBJECTIVE_MOCK_VALUES.find((objective) => objective.keyName === keyName));
              }}
            >
              {displayName}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};

export { ObjectiveDropdownLifecycleFilter };
